import { request } from '@/utils/request'

export class CustomWorkConfiguration {
    constructor() {
        this.__loading = 0
        this.__packages = []
        this.__reportStatuses = []
        this.__initialPackage = null
        this.__initialExecutives = null
        this.__salesContact = null
        this.__showModal = false
    }

    get loading() {
        return this.__loading > 0
    }

    get packages() {
        if (this.__packages.length === 0) {
            this.__loadUserConfiguration()
        }

        return this.__packages
    }

    get hasSalesContact() {
        return this.__salesContact !== null
    }

    get salesContact() {
        if (this.__packages.length === 0) {
            this.__loadUserConfiguration()
        }

        return this.__salesContact
    }

    get reportStatuses() {
        if (this.__reportStatuses.length === 0) {
            this.__loadManageConfiguration()
        }

        return this.__reportStatuses
    }

    get initialExecutives() {
        return this.__initialExecutives
    }

    get initialPackage() {
        return this.__initialPackage
    }

    get showModal() {
        return this.__showModal
    }

    show(options = {}) {
        this.__initialPackage = options.selectedPackage ?? null
        this.__initialExecutives = options.executives ?? null

        if (this.__initialExecutives && !this.__initialExecutives.map) {
            this.__initialExecutives = [options.executives]
        }

        this.__showModal = true
    }

    hide() {
        this.__showModal = false
    }

    async __loadUserConfiguration() {
        if (this.__loading > 0) {
            return
        }

        this.__loading += 1
        try {
            this.__apply(await request.get('/api/custom-work-items/configuration'))
        } catch {
            // yuck
        }
        this.__loading -= 1
    }

    async __loadManageConfiguration() {
        if (this.__loading > 1) {
            return
        }

        this.__loading += 2

        try {
            this.__apply(await request.get('/api/manage/custom-work-items/configuration'))
        } catch {
            // yuck
        }

        this.__loading -= 2
    }

    __apply(content) {
        if (content.packages) {
            this.__packages = content.packages
        }

        if (content.reportStatuses) {
            this.__reportStatuses = content.reportStatuses
        }

        if (content.salesContact) {
            this.__salesContact = content.salesContact
        }
    }
}
